import { IPortalUser } from '@experiences/interfaces';

import { get } from '../utility/Requests.default';

export const userOrganizationInfoUri = '/api/organization/UserOrganizationInfo';

export function getUserOrganizationInfo(token?: string) {
    return get<IPortalUser>(userOrganizationInfoUri, { accessToken: token });
}
